import React from 'react';
import { Link } from 'react-router-dom';

const icons = {
  chat: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  ),
  scan: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 7V5a2 2 0 012-2h2M17 3h2a2 2 0 012 2v2M21 17v2a2 2 0 01-2 2h-2M7 21H5a2 2 0 01-2-2v-2" />
      <circle cx="12" cy="12" r="3" strokeWidth={1.5} />
    </>
  ),
  help: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  ),
};

export default function MarketplaceFloatingDock() {
  const items = [
    { label: 'Messages', href: '/messages', k: 'chat' },
    { label: 'Source by category', href: '/all-categories', k: 'gallery' },
    { label: 'Compare', href: '/compare', k: 'scan' },
    { label: 'Help', href: '/faq', k: 'help' },
  ];

  return (
    <div className="mh-floating-dock hidden xl:flex fixed right-3 top-1/2 -translate-y-1/2 z-[90] flex-col gap-2">
      <div className="mh-floating-dock-inner rounded-2xl bg-white shadow-b2b-hover border border-gray-100 py-2 px-1 flex flex-col gap-1">
        {items.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            title={item.label}
            className="p-2.5 rounded-xl text-gray-600 hover:bg-orange-50 hover:text-b2b-orange transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {item.k === 'gallery' ? (
                <>
                  <rect x="3" y="3" width="7" height="7" rx="1" strokeWidth={1.5} fill="none" />
                  <rect x="14" y="3" width="7" height="7" rx="1" strokeWidth={1.5} fill="none" />
                  <rect x="3" y="14" width="7" height="7" rx="1" strokeWidth={1.5} fill="none" />
                  <rect x="14" y="14" width="7" height="7" rx="1" strokeWidth={1.5} fill="none" />
                </>
              ) : (
                icons[item.k]
              )}
            </svg>
          </Link>
        ))}
        <button
          type="button"
          title="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="p-2.5 rounded-xl text-gray-600 hover:bg-orange-50 hover:text-b2b-orange transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}
